import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

function SonucTablo({ veri, tip }) {
    if (tip === "ccpuan" && veri.live !== undefined) {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <Card>
                        <VuiBox p={3}>
                            <VuiTypography variant="lg" color="success" fontWeight="bold" mb="10px">
                                Live ({(veri.live || []).length})
                            </VuiTypography>
                            {(veri.live || []).map((x, i) => (
                                <VuiBox key={i} mb={1} p={1.5} sx={{ background: "rgba(0,255,0,0.05)", borderRadius: "8px" }}>
                                    <VuiTypography variant="caption" color="white">
                                        {x.mesaj || x.message} — {x.detay || x.details}
                                    </VuiTypography>
                                </VuiBox>
                            ))}
                            {(veri.live || []).length === 0 && (
                                <VuiTypography variant="caption" color="text">Canlı kart bulunamadı.</VuiTypography>
                            )}
                        </VuiBox>
                    </Card>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Card>
                        <VuiBox p={3}>
                            <VuiTypography variant="lg" color="error" fontWeight="bold" mb="10px">
                                Bad ({(veri.bad || []).length})
                            </VuiTypography>
                            {(veri.bad || []).map((x, i) => (
                                <VuiBox key={i} mb={1} p={1.5} sx={{ background: "rgba(255,0,0,0.05)", borderRadius: "8px" }}>
                                    <VuiTypography variant="caption" color="white">
                                        {x.mesaj || x.message} — {x.detay || x.details}
                                    </VuiTypography>
                                </VuiBox>
                            ))}
                            {(veri.bad || []).length === 0 && (
                                <VuiTypography variant="caption" color="text">Ölü kart bulunamadı.</VuiTypography>
                            )}
                        </VuiBox>
                    </Card>
                </Grid>
            </Grid>
        );
    }

    const satirlar = Array.isArray(veri) ? veri : typeof veri === "object" && veri !== null ? [veri] : [];
    if (satirlar.length === 0) {
        return (
            <Card>
                <VuiBox p={3} textAlign="center">
                    <VuiTypography variant="button" color="text">Sonuç bulunamadı.</VuiTypography>
                </VuiBox>
            </Card>
        );
    }

    const alanlar = new Set();
    satirlar.forEach((s) => {
        if (s && typeof s === "object") Object.keys(s).forEach((a) => alanlar.add(a));
    });
    const basliklar = Array.from(alanlar);

    return (
        <Card>
            <VuiBox p={3}>
                <VuiTypography variant="lg" color="white" fontWeight="bold" mb="15px">
                    Sonuçlar ({satirlar.length})
                </VuiTypography>
                <VuiBox sx={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                {basliklar.map((b) => (
                                    <th
                                        key={b}
                                        style={{
                                            padding: "10px 14px",
                                            textAlign: "left",
                                            fontSize: "11px",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                            color: "#a0aec0",
                                            borderBottom: "1px solid rgba(255,255,255,0.1)",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {b.replace(/_/g, " ")}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {satirlar.map((satir, i) => (
                                <tr key={i} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                                    {basliklar.map((b) => {
                                        let d = satir[b];
                                        if (typeof d === "object" && d !== null) d = JSON.stringify(d);
                                        return (
                                            <td
                                                key={b}
                                                style={{
                                                    padding: "10px 14px",
                                                    fontSize: "13px",
                                                    color: "#fff",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {d ?? "-"}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </VuiBox>
            </VuiBox>
        </Card>
    );
}

export default SonucTablo;
